import { useTranslation } from 'react-i18next'

import { Card, CardTitle, MDPartialSummary, SummaryAmount } from '@reveni-io/reveni-ui'

import useCustomLogisticsLabel from '@/common/hooks/useCustomLogisticsLabel/useCustomLogisticsLabel'
import InformationAboutPaymentAndRefund from '@/returns/components/InformationAboutPaymentAndRefund/InformationAboutPaymentAndRefund'
import { statuses } from '@/returns/constants'

import TransactionSummaryCardSkeleton from './TransactionSummaryCardSkeleton/TransactionSummaryCardSkeleton'
import { getLineItemsToReturn, getNewRequestedLineItems, getRejectedLineItems } from './helpers'
import * as Styles from './styles'

const TransactionSummaryCard = ({
  loading,
  data,
  onIssueRefund,
  onCancelStoreCredit,
  onCancelGiftCard,
  disabledIssueRefund,
  onPutRefundOnHold,
  allowPutRefundOnHold,
  onMarkAsIssued,
  onMarkAsPaid,
  allowMarkAsIssued,
  allowCancelStoreCredit,
  allowCancelGiftCard,
  allowMarkAsPaid,
}) => {
  const { t } = useTranslation()
  const customLogisticsLabel = useCustomLogisticsLabel()

  if (loading) return <TransactionSummaryCardSkeleton />

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Desglose transacción')}</CardTitle>
      <Styles.Container>
        {data?.status !== statuses.cancelled && (
          <SummaryAmount
            currency={data?.summary?.currency}
            amount={data?.summary?.summary_total_amount}
            paymentAmount={data?.summary?.payment_amount}
            refundAmount={data?.summary?.refund_amount}
            refundStatus={data?.summary?.refund_status}
            adjustments={data?.refund_info?.adjustment_refunds}
            refundMethod={data?.refund_info?.refund_method}
            onIssueRefund={onIssueRefund}
            onCancelStoreCredit={onCancelStoreCredit}
            onCancelGiftCard={onCancelGiftCard}
            disabledIssueRefund={disabledIssueRefund}
            onPutRefundOnHold={onPutRefundOnHold}
            allowPutRefundOnHold={allowPutRefundOnHold}
            exchangeForOrderPaymentStatus={data?.exchanged_for_order?.payment_status}
            transactionType={data?.transaction_type}
            paymentStatus={data?.summary?.payment_status}
            onMarkAsIssued={onMarkAsIssued}
            allowMarkAsIssued={allowMarkAsIssued}
            allowCancelStoreCredit={allowCancelStoreCredit}
            allowCancelGiftCard={allowCancelGiftCard}
            onMarkAsPaid={onMarkAsPaid}
            allowMarkAsPaid={allowMarkAsPaid}
            summaryStatus={data?.summary?.status}
            pendingAmount={data?.summary?.pending_amount}
          />
        )}
        <MDPartialSummary
          productsToReturn={{
            total: data?.summary?.returned_items_amount,
            products: getLineItemsToReturn(data?.line_items),
          }}
          newRequestedProducts={{
            total: data?.summary?.exchange_items_amount,
            products: getNewRequestedLineItems(data?.line_items, data?.new_items),
          }}
          rejectedProducts={{
            total: data?.summary?.rejected_amount,
            products: getRejectedLineItems(data?.line_items),
          }}
          reveniCoverage={{
            total: data?.summary?.reveni_coverage_amount,
            coverages: { rejected_items: data?.summary?.rejected_amount },
          }}
          fees={{ total: data?.summary?.fee_amount, fees: data?.summary?.fees }}
          bonuses={{ total: data?.summary?.bonus_amount, bonuses: data?.summary?.bonuses }}
          redeemedAmount={data?.summary?.redeemed_amount}
          currency={data?.summary?.currency}
          exchangeAdjustmentAmount={data?.summary?.exchange_adjustment_amount}
          customLogisticsLabel={customLogisticsLabel}
        />
        {data?.status !== statuses.cancelled && (
          <InformationAboutPaymentAndRefund
            isInstant={data?.is_instant}
            exchangedForOrder={data?.exchanged_for_order}
            issueExchangeAtStatus={data?.issue_exchange_at_status}
            paymentStatus={data?.summary?.payment_status}
            refundStatus={data?.summary?.refund_status}
            remainingAmount={data?.summary?.remaining_amount}
            summaryTotalAmount={data?.summary?.summary_total_amount}
            transactionStatus={data?.status}
            transactionType={data?.transaction_type}
          />
        )}
      </Styles.Container>
    </Card>
  )
}

export default TransactionSummaryCard
